<nav class="u-m-b-16">
  <ul class="breadcrumbs">
    <li>Sql Query</li>
  </ul>
</nav>
<header class="u-m-b-40">
  <div class="row">
    <div class="columns">
      <h1 class="typography--display1">Sql Query</h1>
    </div>
  </div>
</header>
<main role="main u-m-t-20">
  <div class="row">
    <div class="columns">
      <div class="card spinner-section" [class.spinner-section--is-active]="(sqlQueryState$ | async)?.loading">
        <div class="spinner-section__icon"></div>
        <sql-query-header [dataResults]="(queryResponse$ | async)?.data" (criteriaChangeEvent)="onCriteriaChange($event)"></sql-query-header>
        <div class="columns">
          <span></span>
        </div>
        <form name="form" aria-label="Run sql query" novalidate [formGroup]="form" (ngSubmit)="executeQuery()">
          <div class="advanced-search__field">
            <textarea #editor style="height: 200px; border: 1px solid #ccc; margin: 0px 30px" formControlName="sql"></textarea>
          </div>
          <div class="row align-left" style="margin-left: 10px; margin-bottom: 20px">
            <div class="advanced-search__submit btn-group">
              <button type="submit" class="btn btn--elevated btn-group__btn">Run</button>
            </div>
          </div>
        </form>
        <div *ngIf="(queryResponse$ | async)?.message?.length > 0">
          <h4 style="color: red">{{ (queryResponse$ | async)?.message }}</h4>
        </div>
      </div>
    </div>
  </div>
  <div class="row" style="margin-top: 20px">
    <div class="columns">
      <div class="card">
        <!-- HORIZONTAL SCROLL CONTAINER – ALL STYLES INLINE -->
        <div
          style="overflow-x: auto; overflow-y: visible; border: 1px solid #ddd; border-radius: 6px; -webkit-overflow-scrolling: touch; padding: 1px"
          *ngIf="(queryResponse$ | async)?.data.length > 0"
        >
          <div class="table" role="table" style="min-width: 800px">
            <ng-container *ngIf="queryResponse$ | async as response">
              <!-- HEADER ROW – STICKY WITH INLINE STYLE -->
              <div role="rowgroup">
                <div
                  class="table__row table__row--header"
                  role="row"
                  style="position: sticky; top: 0; background: white; z-index: 10; box-shadow: 0 2px 4px -2px rgba(0, 0, 0, 0.1); flex-flow: row"
                >
                  <span
                    class="table__cell table__cell--align-left"
                    role="columnheader"
                    *ngFor="let column of getKeys(response.data[0])"
                    [title]="column"
                    [style]="getStyle(column)"
                  >
                    {{ column }}
                  </span>
                </div>
              </div>

              <!-- DATA ROWS -->
              <div role="rowgroup">
                <a
                  class="table__row ng-scope"
                  role="row"
                  *ngFor="let rowObj of response.data; odd as isOdd; last as isLast"
                  [class.table__row--alt]="isOdd"
                  [class.table__row--last]="isLast"
                  style="flex-flow: row"
                >
                  <span
                    class="table__cell table__cell--align-left"
                    role="cell"
                    *ngFor="let column of getKeys(rowObj)"
                    [style]="getStyle(column)"
                    [title]="rowObj[column]"
                  >
                    {{ displayValue(rowObj, column) }}
                  </span>
                </a>
              </div>
            </ng-container>
          </div>
        </div>
        <!-- END OF SCROLL CONTAINER -->
      </div>
    </div>
  </div>
</main>
